import type { Amount, ContractType } from '@/types/calculation'

declare global {
  interface Window {
    /** Google Tag Manager reads whatever lands here; the site loads GTM, the tool only pushes. */
    dataLayer?: object[]
  }
}

/**
 * The five funnel events for the salderingscheck (#6321), pushed the same way the choice engines
 * do. salderingstool_ingevuld and salderingstool_lead are fixed names from Relevant Online (epic
 * #106); the net_metering_* names are ours. No email address or other personal data goes into any
 * event: this is an anonymous tool, minimal data in third-party tools (decision on #6321).
 */

/** The visitor touched the input step for the first time. */
export function trackStart(contractType: ContractType | ''): void {
  pushDataLayer(withContractType('net_metering_start', contractType))
}

/** The visitor clicked the calculate button and the input passed the local checks. */
export function trackCalculationStarted(contractType: ContractType | ''): void {
  pushDataLayer(withContractType('net_metering_calculation_started', contractType))
}

/** The result is on screen: the visitor ran the tool to the end. Fixed name. */
export function trackCompleted(contractType: ContractType | '', difference: Amount): void {
  pushDataLayer({
    ...withContractType('salderingstool_ingevuld', contractType),
    difference_monthly: difference.monthly,
    difference_annual: difference.annual,
  })
}

/** The visitor requested the action plan: the conversion. Fixed name. */
export function trackLead(contractType: ContractType | '', newsletterOptIn: boolean): void {
  pushDataLayer({
    ...withContractType('salderingstool_lead', contractType),
    newsletter_opt_in: newsletterOptIn,
  })
}

/** The calculation could not be made: a tariff is missing for this situation. */
export function trackCalculationFailed(contractType: ContractType | ''): void {
  pushDataLayer(withContractType('net_metering_calculation_failed', contractType))
}

/** Empty means not chosen yet; the key stays off the event rather than carrying ''. */
function withContractType(event: string, contractType: ContractType | ''): Record<string, unknown> {
  return contractType === '' ? { event } : { event, contract_type: contractType }
}

function pushDataLayer(data: object): void {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(data)
}
